<template>
  <el-container class="layout-container-demo">
    <!-- Header -->
    <el-header class="shadow-lg d-print-none" style="padding: 0; height: 70px">
      <b-card class="p-0 m-0" no-body>
        <NavBarComp />
      </b-card>
    </el-header>

    <!-- Body -->
    <el-container>
      <!-- Sidebar -->
      <el-aside class="shadow-lg d-print-none sidebar" width="auto">
        <b-card class="p-0 m-0 h-100 d-flex flex-column" no-body>
          <!-- Scrollable Menu -->
          <div class="menu-scroll">
            <el-scrollbar>
              <Menu />
            </el-scrollbar>
          </div>

          <!-- Fixed Footer -->
          <div class="sidebar-footer text-center py-2">
            <span class="logo-lg" style="cursor: pointer" @click="goToExternalSite">
              <img :src="tenantInfo?.logo ?? ''" class="img-thumbnail shadow" width="40" />
            </span>
            <el-tooltip :content="tenantInfo?.tenant_name" effect="light" placement="top">
              <div class="text-center" style="cursor: pointer" @click="goToExternalSite">
                <div class="text-truncate" style="max-width: 55px; margin: auto">
                  {{ tenantInfo?.tenant_name }}
                </div>
              </div>
            </el-tooltip>
          </div>
        </b-card>
      </el-aside>

      <!-- Main -->
      <el-main class="main-scroll">
        <div style="min-height: 100%">
          <slot />
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import NavBarComp from '@/components/nav-bar.vue';
import usePlanPrice from '@/composable/plan-price';

const { tenantInfo } = usePlanPrice();

function goToExternalSite() {
  if (tenantInfo?.value?.website) {
    window.open(tenantInfo.value.website, '_blank');
  }
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}

.layout-container-demo {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.layout-container-demo > .el-container {
  flex: 1;
  display: flex;
  overflow: hidden; /* Prevent global scroll */
}

/* Sidebar Layout */
.sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.menu-scroll {
  flex: 1;
  overflow: hidden; /* Let el-scrollbar handle scrolling */
}

.sidebar-footer {
  flex-shrink: 0; /* Fixed at bottom */
}

/* Main Content Scroll */
.main-scroll {
  flex: 1;
  overflow-y: auto; /* Scroll only inside main */
  padding: 20px;
}

@media print {
  .main-scroll {
    height: auto;
    overflow: visible;
  }
}
</style>
